import httpRequest, { ApiConfig } from 'httpRequest'
import {
    ClientContract,
    ClientOnlineStatus,
    ClientType,
    CurrentClientContract,
    SelectClientContract,
} from 'models'

const CLIENT_PREFIX = '/client'
export interface IRegisterParam {
    clientName: string
    clientType: ClientType
}
const clientService = {
    validateServerKey: () => httpRequest.get(`${CLIENT_PREFIX}/validate`),
    getCurrentClient: () =>
        httpRequest.get<CurrentClientContract>(
            `${CLIENT_PREFIX}/current-client`,
        ),
    registerWebClient: ({ clientType, clientName = '' }: IRegisterParam) =>
        httpRequest.get<ClientContract>(
            `${CLIENT_PREFIX}/register-web-client`,
            {
                params: {
                    name: clientName,
                    type: clientType,
                },
            },
        ),
    injectOnlineOrder: () => httpRequest.get('/client/inject-online-order'),
    getClients: (config?: ApiConfig) =>
        httpRequest.get<SelectClientContract[]>('/client/clients', config),
    getClientOnlineStatus: (showConnectivity: boolean) =>
        httpRequest.get<ClientOnlineStatus[]>('/client/online-status', {
            params: { showConnectivity },
        }),
}

export default clientService
